import styled from "styled-components";
import { Flex } from "@evergis/ui";

import { FILTERED_VALUE_OPACITY } from "../../constants";

export const ChartLegendContainer = styled(Flex)<{ twoColumns?: boolean }>`
  flex-direction: column;
  justify-content: ${({ twoColumns }) => (twoColumns ? "flex-start" : "center")};
`;

export const ChartLegendItem = styled(Flex)<{
  isFiltered?: boolean;
  hasAnyFilter?: boolean;
  onClick?: (value: string) => void;
}>`
  cursor: ${({ onClick }) => (onClick ? "pointer" : "default")};
  align-items: center;
  flex-wrap: nowrap;
  margin-right: 0.375rem;
  margin-bottom: 0.25rem;
  opacity: ${({ isFiltered, hasAnyFilter }) => (isFiltered ? 1 : hasAnyFilter ? FILTERED_VALUE_OPACITY / 100 : 1)};
`;

export const ChartLegendColor = styled.div<{ color: string }>`
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 0.375rem;
  background-color: ${({ color }) => color};
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.tiny};
`;

export const ChartLegendName = styled.div<{ $fontColor?: string }>`
  flex: 1;
  font-size: 0.625rem;
  color: ${({ theme: { palette }, $fontColor }) => $fontColor || palette.textPrimary};
`;
